'use strict';

/*!
 * Here comes description.
 *
 * @package tokai-univ
 */
const $ = jQuery;

/*!
 * @deps jquery
 */

const topVisualTagsList = $( '.js-top-visual-tags' );
const intervalTime = 5400;
let activeTagItem;
let currentTagItem;
let nextTagItem;
let tagStateFlag = true;

$( window ).on( 'load', function () {
	if ( topVisualTagsList.length ) {
		//stop changing tags when mouse on the element
		topVisualTagsList.mouseover( function ( e ) {
			tagStateFlag = false;
		} ).mouseout( function ( e ) {
			tagStateFlag = true;
		} );
		//change tags
		setInterval( function () {
			if ( tagStateFlag === true ) {
				tagStateFlag = false;
				activeTagItem = $( '.js-top-visual-tag-item.active' );
				currentTagItem = $( '.js-top-visual-tag-item.current' );
				if ( ! currentTagItem.next( '.js-top-visual-tag-item' ).length ) {
					nextTagItem = $( '.js-top-visual-tag-item:first-child' );
				} else {
					nextTagItem = currentTagItem.next( '.js-top-visual-tag-item' );
				}
				//1.Fade-out active item
				activeTagItem.addClass( 'past' );
				//2.Remove current item
				setTimeout( function () {
					currentTagItem.removeClass( 'current' );
					$( '.js-top-visual-tag-item.active' ).removeClass( 'active' );
				}, 800 );
				//3.Set next current item
				setTimeout( function () {
					nextTagItem.addClass( 'current' );
				}, 1100 );
				//4.Fade-in active item
				setTimeout( function () {
					nextTagItem.addClass( 'active' );
					$( '.js-top-visual-tag-item.past' ).removeClass( 'past' );
				}, 1600 );
				//5.Back to loop start
				setTimeout( function () {
					tagStateFlag = true;
				}, 5200 );
			}
		}, intervalTime );
	}

	if ( $( '.top-visual-special-info' ).length ) {
		$( '.wp-block-tokai-top-visual' ).addClass( 'has-special-info' );
	}
} );

